'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../node_modules/@babel/runtime/helpers/esm/extends.js');

var objectSpread2 = require('../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js');

var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js');

var createClass = require('../../node_modules/@babel/runtime/helpers/esm/createClass.js');

var assertThisInitialized = require('../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js');

var inherits = require('../../node_modules/@babel/runtime/helpers/esm/inherits.js');

var createSuper = require('../../node_modules/@babel/runtime/helpers/esm/createSuper.js');

var defineProperty = require('../../node_modules/@babel/runtime/helpers/esm/defineProperty.js');

var React = require('react');

var index$1 = require('../../node_modules/classnames/index.js');

var index = require('../../node_modules/prop-types/index.js');

var focusTrapReact = require('../../node_modules/focus-trap-react/dist/focus-trap-react.js');

var index$2 = require('../../utilities/index.js');

var Transition = require('../../node_modules/react-transition-group/esm/Transition.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var _excluded = ["animation", "backdrop", "backdropClassName", "backdropTransitionTimeout", "cascading", "centered", "children", "className", "contentClassName", "disableFocusTrap", "fade", "frame", "fullHeight", "id", "inline", "isOpen", "keyboard", "modalStyle", "modalStylesWithoutBackdrop", "modalTransitionTimeout", "noClickableBodyWithoutBackdrop", "overflowScroll", "position", "role", "side", "size", "tabIndex", "toggle", "wrapClassName", "wrapperStyles", "zIndex"];

var Modal = /*#__PURE__*/function (_Component) {
  inherits['default'](Modal, _Component);

  var _super = createSuper['default'](Modal);

  function Modal() {
    var _this;

    classCallCheck['default'](this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    defineProperty['default'](assertThisInitialized['default'](_this), "state", {
      initialIsOpen: _this.props.isOpen || false
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "modalContent", /*#__PURE__*/React__default['default'].createRef());
    defineProperty['default'](assertThisInitialized['default'](_this), "componentDidMount", function () {
      document.body.classList.add('modal-open');
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "componentWillUnmount", function () {
      document.body.classList.remove('modal-open');
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "componentDidUpdate", function (prevProps, prevState) {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          overflowScroll = _this$props.overflowScroll;
      var overflowStatement = overflowScroll ? 'overflow-y-scroll' : 'overflow-hidden';

      if (prevState.initialIsOpen !== isOpen) {
        _this.setState({
          initialIsOpen: isOpen
        }, function () {
          if (isOpen) {
            document.body.classList.add(overflowStatement);
          } else {
            document.body.classList.remove(overflowStatement);
          }
        });
      }
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "handleOnEntered", function (type, node) {
      if (type === 'backdrop' && _this.props.fade === false) {
        return;
      }

      node.classList.add('show');
      _this.props.autoFocus && node.focus();

      if (type === 'modal') {
        _this.props.showModal && _this.props.showModal();
      }
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "handleOnExit", function (type, node) {
      if (type === 'backdrop' && _this.props.fade === false) {
        return;
      }

      node.classList.remove('show');

      if (type === 'modal') {
        _this.props.hideModal && _this.props.hideModal();
      }
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "handleOnExited", function () {
      _this.props.hiddenModal && _this.props.hiddenModal();
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "handleBackdropClick", function (e) {
      if (!_this.props.backdrop || e.target.closest('[role="dialog"]') && !e.target.classList.contains('modal')) {
        return;
      }

      if (!(e.clientX > e.target.clientWidth || e.clientY > e.target.clientHeight)) {
        if (!_this.modalContent.contains(e.target)) {
          if (!_this.props.disableBackdrop) {
            _this.props.toggle();
          }
        }
      }
    });
    defineProperty['default'](assertThisInitialized['default'](_this), "handleEscape", function (e) {
      if (_this.props.keyboard && e.keyCode === 27) {
        e.preventDefault();

        _this.props.toggle();
      }
    });
    return _this;
  }

  createClass['default'](Modal, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          animation = _this$props2.animation,
          backdrop = _this$props2.backdrop,
          backdropClassName = _this$props2.backdropClassName,
          backdropTransitionTimeout = _this$props2.backdropTransitionTimeout,
          cascading = _this$props2.cascading,
          centered = _this$props2.centered,
          children = _this$props2.children,
          className = _this$props2.className,
          contentClassName = _this$props2.contentClassName,
          disableFocusTrap = _this$props2.disableFocusTrap,
          fade = _this$props2.fade,
          frame = _this$props2.frame,
          fullHeight = _this$props2.fullHeight,
          id = _this$props2.id,
          inline = _this$props2.inline;
      _this$props2.isOpen;
      _this$props2.keyboard;
      var modalStyle = _this$props2.modalStyle,
          modalStylesWithoutBackdrop = _this$props2.modalStylesWithoutBackdrop,
          modalTransitionTimeout = _this$props2.modalTransitionTimeout,
          noClickableBodyWithoutBackdrop = _this$props2.noClickableBodyWithoutBackdrop;
      _this$props2.overflowScroll;
      var position = _this$props2.position,
          role = _this$props2.role,
          side = _this$props2.side,
          size = _this$props2.size,
          tabIndex = _this$props2.tabIndex;
      _this$props2.toggle;
      var wrapClassName = _this$props2.wrapClassName,
          wrapperStyles = _this$props2.wrapperStyles;
      _this$props2.zIndex;
      var attributes = objectWithoutProperties['default'](_this$props2, _excluded);
      var initialIsOpen = this.state.initialIsOpen;

      var whichPosition = function whichPosition() {
        if (position === 'bottom-right') {
          return {
            top: 'auto',
            bottom: 10,
            right: 10,
            left: 'auto'
          };
        } else if (position === 'bottom-left') {
          return {
            top: 'auto',
            bottom: 10,
            right: 'auto',
            left: 10
          };
        } else if (position === 'top-right') {
          return {
            top: 10,
            bottom: 'auto',
            right: 10,
            left: 'auto'
          };
        } else if (position === 'top-left') {
          return {
            top: 10,
            bottom: 'auto',
            right: 'auto',
            left: 10
          };
        } else if (position === 'right') {
          return {
            right: 0
          };
        } else if (position === 'left') {
          return {
            left: 0
          };
        } else if (position === 'bottom') {
          return {
            bottom: 0
          };
        } else if (position === 'top') {
          return {
            top: 0
          };
        } else {
          return {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
          };
        }
      };

      var timeout = fade ? modalTransitionTimeout : 0;
      var backdropTimeout = fade ? backdropTransitionTimeout : 0;
      var removeBackdropClass = objectSpread2['default'](objectSpread2['default']({
        position: 'fixed'
      }, whichPosition()), modalStylesWithoutBackdrop);
      var removeBackdropConditions = !backdrop && initialIsOpen && !noClickableBodyWithoutBackdrop;
      var modalDialogClasses = index$1['default']((_classNames = {
        'cascading-modal': cascading,
        'modal-side': side,
        'modal-full-height': fullHeight,
        'modal-frame': frame,
        'modal-dialog-centered': centered
      }, defineProperty['default'](_classNames, "modal-".concat(size), size), defineProperty['default'](_classNames, "modal-".concat(position), position), defineProperty['default'](_classNames, "modal-notify white-text modal-".concat(modalStyle), modalStyle), _classNames), 'modal-dialog', className);
      var splitPosition = position.split('-');
      var wrapperClasses = index$1['default']({
        modal: !inline,
        fade: fade,
        top: fade && !animation && !position,
        animation: fade && animation
      }, fade && position && position && splitPosition.length > 1 ? splitPosition[1] : splitPosition[0], wrapClassName);
      var backdropClasses = index$1['default']('modal-backdrop', fade ? 'fade' : 'show', backdropClassName);
      var contentClasses = index$1['default']('modal-content', contentClassName);
      var modalAttributes = index$2.returnAttributes(objectSpread2['default']({
        style: {
          display: 'block',
          position: removeBackdropConditions && 'fixed',
          width: removeBackdropConditions && 0
        },
        id: id,
        tabIndex: tabIndex,
        role: role,
        'aria-hidden': 'true'
      }, attributes));
      var styles = removeBackdropConditions ? removeBackdropClass : {};
      var modal = /*#__PURE__*/React__default['default'].createElement("div", _extends['default']({
        "data-test": "modal",
        onKeyUp: this.handleEscape,
        className: wrapperClasses,
        style: wrapperStyles
      }, modalAttributes), /*#__PURE__*/React__default['default'].createElement("div", {
        style: styles,
        className: modalDialogClasses,
        role: "document"
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        ref: function ref(elem) {
          return _this2.modalContent = elem;
        },
        className: contentClasses
      }, children)));
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, backdrop && /*#__PURE__*/React__default['default'].createElement(Transition['default'], {
        timeout: backdropTimeout,
        in: initialIsOpen,
        appear: initialIsOpen,
        mountOnEnter: true,
        unmountOnExit: true,
        onEntered: function onEntered(node) {
          return _this2.handleOnEntered('backdrop', node);
        },
        onExit: function onExit(node) {
          return _this2.handleOnExit('backdrop', node);
        },
        onExited: this.handleOnExited
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: backdropClasses
      })), /*#__PURE__*/React__default['default'].createElement(Transition['default'], {
        timeout: timeout,
        in: initialIsOpen,
        appear: initialIsOpen,
        mountOnEnter: true,
        unmountOnExit: true,
        onMouseDown: function onMouseDown(e) {
          return _this2.handleBackdropClick(e);
        },
        onEntered: function onEntered(node) {
          return _this2.handleOnEntered('modal', node);
        },
        onExit: function onExit(node) {
          return _this2.handleOnExit('modal', node);
        }
      }, !disableFocusTrap ? /*#__PURE__*/React__default['default'].createElement(focusTrapReact['default'], null, modal) : modal));
    }
  }]);
  return Modal;
}(React.Component);

Modal.defaultProps = {
  autoFocus: true,
  backdrop: true,
  backdropTransitionTimeout: 150,
  disableBackdrop: false,
  disableFocusTrap: true,
  fade: true,
  isOpen: false,
  keyboard: true,
  modalTransitionTimeout: 300,
  overflowScroll: true,
  position: '',
  role: 'dialog',
  tabIndex: '-1',
  zIndex: 1050,
  noClickableBodyWithoutBackdrop: false
};
Modal.propTypes = {
  animation: index['default'].string,
  autoFocus: index['default'].bool,
  backdrop: index['default'].bool,
  backdropClassName: index['default'].string,
  backdropTransitionTimeout: index['default'].number,
  cascading: index['default'].bool,
  centered: index['default'].bool,
  children: index['default'].node,
  className: index['default'].string,
  contentClassName: index['default'].string,
  disableBackdrop: index['default'].bool,
  disableFocusTrap: index['default'].bool,
  fade: index['default'].bool,
  frame: index['default'].bool,
  fullHeight: index['default'].bool,
  hiddenModal: index['default'].func,
  hideModal: index['default'].func,
  id: index['default'].string,
  inline: index['default'].bool,
  isOpen: index['default'].bool,
  keyboard: index['default'].bool,
  modalClassName: index['default'].string,
  modalStyle: index['default'].string,
  modalStylesWithoutBackdrop: index['default'].object,
  modalTransitionTimeout: index['default'].number,
  noClickableBodyWithoutBackdrop: index['default'].bool,
  overflowScroll: index['default'].bool,
  position: index['default'].string,
  role: index['default'].string,
  showModal: index['default'].func,
  side: index['default'].bool,
  size: index['default'].string,
  tabIndex: index['default'].string,
  toggle: index['default'].func,
  wrapClassName: index['default'].string,
  wrapperStyles: index['default'].object,
  zIndex: index['default'].oneOfType([index['default'].number, index['default'].string])
};
exports.Modal = Modal;
exports['default'] = Modal;